// Copies of rooms picked from the chips, by slug. A phone screen that switches
// to another room in place (EventEdit, How to Go Live) shows the room's copy
// straight away while it reloads, instead of an empty screen with a spinner.
// Route params can't carry it: on web they become the URL.
const copies = new Map();

export const rememberRoomCopy = (event) => {
  if (event?.slug && event.title) copies.set(event.slug, event);
};

export const roomCopyOf = (slug) => (slug && copies.get(slug)) || null;
